export default function WhatIsSection() {
  return (
    <section id="what-is" className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
              What Is the <span className="text-primary-600">Basetao Spreadsheet</span>?
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-4">
              The Basetao Spreadsheet is a carefully curated product discovery system designed to help shoppers find, compare, and purchase the best products available through Basetao. Think of it as your personal shopping concierge — organized, searchable, and always up to date.
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4">
              Instead of spending hours scrolling through endless product listings across multiple platforms, the Basetao Spreadsheet brings everything together in one clean, structured database. Each entry includes verified product links, community QC reviews, price comparisons, and detailed shopping tips.
            </p>
            <p className="text-foreground-600 leading-relaxed text-sm">
              Whether you are hunting for the latest sneaker releases, looking for premium streetwear, or searching for budget-friendly gems, the Basetao Spreadsheet streamlines your entire shopping journey — from discovery to delivery.
            </p>
          </div>
          <div className="flex-shrink-0 w-full lg:w-[380px]">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20tablet%20displaying%20colorful%20organized%20spreadsheet%20interface%20surrounded%20by%20stylish%20fashion%20accessories%20on%20warm%20terracotta%20desk%20surface%2C%20soft%20diffused%20natural%20daylight%20from%20side%20window%2C%20contemporary%20tech%20lifestyle%20editorial%20photography%2C%20warm%20inviting%20tones%2C%20clean%20professional%20composition&width=800&height=600&seq=what-is-v2&orientation=landscape"
                alt="Basetao Spreadsheet organized product catalog on tablet with fashion items"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}